export const GAME_SLUGS = {
  BJ: 'BJ',
  UBJ: 'UBJ',
  ROU: 'ROU',
  BAC: 'BAC',
  ANDAR: 'ANDAR',
  UAB: 'UAB',
  OTTAB: 'OTTAB',
  TCP: 'TCP',
  CH: 'CH',
  BOTP: 'BOTP',
  ODTP: 'ODTP',
  ODTP_BL: 'ODTP_BL',
  L7: 'L7',
  MAT: 'MAT',
  TTC: 'TTC',
  SICBO: 'SICBO',
  RP: 'RP',
  REVROU: 'REVROU',
  TZROU: 'TZROU',
  UR: 'UR',
  XD: 'XD',
  MR: 'MR',
  BW: 'BW',
  UD: 'UD',
} as const;

export const GAME_ID_TO_SLUGS_MAP = {
  // BACCARAT
  2: GAME_SLUGS.BAC,
  // BACCARAT KO
  20: GAME_SLUGS.BAC,
  // BACCARAT SUPER SIX
  21: GAME_SLUGS.BAC,
  // BACCARAT MULTI SEAT
  22: GAME_SLUGS.BAC,
  // BACCARAT INSURANCE
  23: GAME_SLUGS.BAC,
  // BACCARAT DRAGON TIGER
  24: GAME_SLUGS.BAC,
  // BACCARAT NO COMMISSION
  25: GAME_SLUGS.BAC,
  // BACCARAT DRAGON BONUS
  26: GAME_SLUGS.BAC,
  // BACCARAT QUEENCO
  27: GAME_SLUGS.BAC,
  // BACCARAT PUNTO BANCO
  28: GAME_SLUGS.BAC,
  // BACCARAT CRICKET WAR
  45: GAME_SLUGS.BAC,
  // BACCARAT - EZ BACCARAT
  70: GAME_SLUGS.BAC,
  // BLACKJACK
  1: GAME_SLUGS.BJ,
  // AMERICAN BLACKJACK
  10: GAME_SLUGS.BJ,
  // UNLIMITED BLACKJACK
  12: GAME_SLUGS.BJ,
  // BLACKJACK SALON PRIVE
  46: GAME_SLUGS.BJ,
  // BLACKJACK VIDEO CHAT
  51: GAME_SLUGS.BJ,
  // ROULETTE
  3: GAME_SLUGS.ROU,
  // AUTOMATED ROULETTE
  7: GAME_SLUGS.ROU,
  // ROULETTE PORTOMASO
  29: GAME_SLUGS.ROU,
  // AMERICAN ROULETTE
  31: GAME_SLUGS.ROU,
  // AMERICAN AUTOMATED ROULETTE
  32: GAME_SLUGS.ROU,
  // AMERICAN OTT ROULETTE
  35: GAME_SLUGS.ROU,
  // RNG ROULETTE
  48: GAME_SLUGS.ROU,
  // ANDARBAHAR
  38: GAME_SLUGS.ANDAR,
  // ULTIMATE ANDAR BAHAR
  55: GAME_SLUGS.UAB,
  // OTT ANDAR BAHAR
  39: GAME_SLUGS.OTTAB,
  // THREE CARD POKER
  17: GAME_SLUGS.TCP,
  // BET ON TEEN PATTI
  16: GAME_SLUGS.BOTP,
  // ONE DAY TEEN PATTI
  43: GAME_SLUGS.ODTP,
  // CASINO HOLDEM
  15: GAME_SLUGS.CH,
  // LUCKY 7
  13: GAME_SLUGS.L7,
  // 32 CARDS
  19: GAME_SLUGS.TTC,
  // SICBO
  14: GAME_SLUGS.SICBO,
  // SICBO MULTIPLIER
  52: GAME_SLUGS.SICBO,
  // BACK & LAY ONE DAY TEEN PATTI
  50: GAME_SLUGS.ODTP_BL,
  // RUSSIAN POKER
  53: GAME_SLUGS.RP,
  // ULTIMATE ROULETTE
  54: GAME_SLUGS.UR,
  // MATKA
  57: GAME_SLUGS.MAT,
  // REVOLUTION ROULETTE
  58: GAME_SLUGS.REVROU,
  // MARBLE RACE
  59: GAME_SLUGS.MR,
  // XOC DIA
  60: GAME_SLUGS.XD,
  // REVOLUTION ROULETTE US
  61: GAME_SLUGS.REVROU,
  // ULTIMATE FLIP (XOC DIA MULTIPLIERS)
  62: GAME_SLUGS.XD,
  // TRIPLE ZERO ROULETTE
  63: GAME_SLUGS.TZROU,
  // BONUS WHEEL
  49: GAME_SLUGS.BW,
  // ULTIMATE DICE
  64: GAME_SLUGS.UD,
} as const;

export const GROUP_SLUGS_TO_TITLE_MAP = {
  // BLACKJACK / AMERICAN BLACKJACK
  [GAME_SLUGS.BJ]: 'blackjack',
  // UNLIMITED BLACKJACK
  [GAME_SLUGS.UBJ]: 'unlimited_blackjack',
  // ROULETTE
  [GAME_SLUGS.ROU]: 'roulette',
  // REVOLUTION ROULETTE
  [GAME_SLUGS.REVROU]: 'RevolutionRoulette',
  // ONE DAY TEEN PATTI
  [GAME_SLUGS.ODTP]: 'OneDayTeenPatti',
  // ONE DAY TEEN PATTI BACK AND LAY
  [GAME_SLUGS.ODTP_BL]: 'OneDayTeenPatti_BackAndLay',
  // RUSSIAN POKER
  [GAME_SLUGS.RP]: 'RussianPoker',
  [GAME_SLUGS.UR]: 'UltimateRoulette',
  [GAME_SLUGS.MAT]: 'Matka',
  [GAME_SLUGS.MR]: 'MarbleRace',
  [GAME_SLUGS.BW]: 'BonusWheel',
  [GAME_SLUGS.UD]: 'UltimateDice',
};

export type GameIdToSlugMapKeys = keyof typeof GAME_ID_TO_SLUGS_MAP

export default {
  GROUP_SLUGS_TO_TITLE_MAP,
  GAME_ID_TO_SLUGS_MAP,
  GAME_SLUGS,
} as const;
